import { render } from "./TermOfUse.vue?vue&type=template&id=a556c002&scoped=true"
import script from "./TermOfUse.vue?vue&type=script&lang=js"
export * from "./TermOfUse.vue?vue&type=script&lang=js"

import "./TermOfUse.vue?vue&type=style&index=0&id=a556c002&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a556c002"]])

export default __exports__